exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kIxYcGnczr_o6H_l47FLp{padding-top:20px;padding-bottom:40px;text-align:center;background-color:#3b434f;color:#ccc;position:absolute;bottom:-25;width:100%}.kIxYcGnczr_o6H_l47FLp p{padding-top:18px;margin-bottom:0;font-size:14px;font-weight:300;text-align:left;line-height:1.5}.kIxYcGnczr_o6H_l47FLp p a{color:#ccc;outline:medium none!important;text-decoration:none}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}", ""]);

// exports
exports.locals = {
	"styles": "kIxYcGnczr_o6H_l47FLp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/Footer/styles.scss
// module id = 388
// module chunks = 0